<template>
  <div id="upcoming-races">
    <div class="ml-2 race-filter" v-if="filteredBookie">
      <div class="showing">Showing:</div>
      <div class="mt-6">
        <bookie-icon
          :bookie="filteredBookie"
          :size="30"
          :top="true"
          @click="() => toggleBookieFilter(filteredBookie)"
        />
      </div>
    </div>

    <v-data-iterator
      :items="races"
      no-data-text="No races are currently scheduled"
      :hide-default-footer="!races.length"
      :items-per-page="-1"
      :footer-props="{
        itemsPerPageOptions: [20, 50, 100, -1]
      }"
      class="ml-2"
    >
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <race-panel
              :race="item"
              :show-runners="false"
              :menu="[]"
              @iconClicked="() => toggleBookieFilter(item.bookie)"
            />
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import RacePanel from "../components/RacePanel";
import BookieIcon from "../components/BookieIcon";

export default {
  name: "UpcomingRaces",
  components: {
    RacePanel,
    BookieIcon
  },
  data() {
    return {
      filteredBookie: null
    };
  },
  computed: {
    races() {
      return this.$store.getters.upcomingRaces.filter(r =>
        this.filteredBookie ? r.bookie === this.filteredBookie : true
      );
    }
  },
  methods: {
    toggleBookieFilter(bookie) {
      if (this.filteredBookie === bookie) {
        this.filteredBookie = null;
      } else {
        this.filteredBookie = bookie;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.race-filter {
  display: flex;
  align-items: center;

  .showing {
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
